var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStateNomoney(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 300,
    height: 299,
    viewBox: "0 0 300 299",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "a",
    width: "163%",
    height: "167.3%",
    x: "-31.5%",
    y: "-33.7%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "SourceGraphic",
    stdDeviation: 17.943
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: "36.036%",
    x2: "76.471%",
    y1: "-34.578%",
    y2: "178.606%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#61DB99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#00A09A"
  })), /*#__PURE__*/React.createElement("path", {
    id: "c",
    d: "M76.95 133.247h-.525L0 80.082v112.975s48.26-40.648 74.009-58.129c.947-.641 1.94-1.173 2.94-1.681z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "d",
    d: "M239.417 232.083l-74.943-58.04c-9.158-6.297-21.282-6.33-30.477-.09-25.751 17.482-74.012 58.13-74.012 58.13h179.432z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#00C4B3"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 149.701,
    cy: 149.562,
    opacity: 0.03,
    rx: 149.526,
    ry: 149.388
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 150.1,
    cy: 149.973,
    opacity: 0.04,
    rx: 99.684,
    ry: 99.592
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#053871",
    fillOpacity: 0.66,
    d: "M161.792 98.124l-60.849-59.37c-6.332-7.414-16.122-7.414-22.455 0L17.64 98.125l-9.203 94.401 170.995.532-17.64-94.933z",
    filter: "url(#a)",
    transform: "translate(59.985 39.025)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M239.417 117.635l-73.215-71.573c-9.141-8.939-23.861-8.939-33.002 0l-73.215 71.573v114.448h179.432V117.635z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2B8272",
    d: "M77.086 124.475l41.8-20.535c1.24-.612 2.694-.068 3.282 1.08l39.3 77.59c.612 1.236.066 2.69-1.085 3.278l-41.888 20.558c-1.238.612-2.693.068-3.281-1.08l-39.212-77.613c-.612-1.237-.154-2.666 1.084-3.278z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BDEADB",
    fillOpacity: 0.556,
    d: "M127.986 128.479l-9.263-18.521c-.25-.586-1.065-.835-1.652-.584L81.724 126.78c-.588.25-.837 1.064-.586 1.65l9.263 18.521c.25.587 1.065.835 1.652.584.587-.25.837-1.064.586-1.65l-8.698-17.46 33.109-16.339 8.698 17.46c.25.586 1.065.834 1.652.583.564-.337.837-1.064.586-1.65z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#28AB8A",
    d: "M84.674 107.786L128.34 91.42c1.285-.438 2.653.13 3.177 1.39l34.252 84.915c.437 1.283-.132 2.65-1.417 3.087l-43.665 16.367c-1.285.438-2.652-.13-3.177-1.389l-34.251-84.916c-.414-1.196.219-2.672 1.416-3.087z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BDEADB",
    fillOpacity: 0.556,
    d: "M127.606 97.403c-.251-.586-.914-.968-1.589-.694l-36.874 13.8c-.587.251-.97.914-.696 1.587l7.35 19.407c.25.587.914.969 1.588.695.587-.25.97-.914.697-1.587l-6.85-18.234 34.59-12.909 6.849 18.234c.25.587.914.969 1.588.695.587-.25.97-.914.697-1.587l-7.35-19.407z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#b)",
    d: "M29.754 0h47.407a2.522 2.522 0 0 1 2.528 2.525v94.223a2.522 2.522 0 0 1-2.528 2.525H29.754a2.522 2.522 0 0 1-2.528-2.525V2.525C27.226 1.082 28.309 0 29.754 0z",
    transform: "rotate(-15 415.435 -209.707)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FBFBFB",
    fillOpacity: 0.667,
    d: "M115.415 139.128c2.59 9.668 12.517 15.316 22.112 12.745 9.594-2.57 15.344-12.513 12.777-22.093s-12.518-15.315-22.112-12.745c-9.594 2.571-15.344 12.513-12.777 22.093zm7.995-2.609l1.308-.35c-.321-2.248.456-4.23 1.578-5.277.15-.134.39-.29.564-.338.697-.187 1.36.196 1.524.805.14.523-.052.854-.266 1.098-.703 1.216-1.185 2.558-.765 4.126.537 2.003 1.492 2.774 2.887 2.4 3.402-.911-.339-8.59 5.243-10.086 2.094-.56 4.165.191 5.284 2.972l1.308-.351c.611-.164 1.251.132 1.414.741.164.61-.243 1.186-.853 1.35l-1.309.35c.205 1.812-.096 3.48-1.02 4.567-.127.221-.366.378-.715.472a1.234 1.234 0 0 1-1.548-.892c-.093-.349.012-.657.267-1.099.511-.883.731-2.156.381-3.462-.49-1.83-1.549-2.292-2.508-2.035-3.053.818.513 8.544-5.244 10.086-2.53.678-4.607-.446-5.749-3.313l-1.308.35c-.61.164-1.25-.131-1.414-.741a1.266 1.266 0 0 1 .94-1.373zm36.075 18.805c-.698.187-1.145.96-.958 1.657l3.617 13.5-36.633 9.815-3.617-13.5c-.187-.696-.96-1.142-1.659-.955-.698.187-1.145.96-.958 1.657l3.967 14.806c.187.697.96 1.143 1.659.956l39.25-10.517c.697-.187 1.145-.96.958-1.657l-3.967-14.806c-.187-.697-.961-1.143-1.659-.956zm-18.67-69.675l-39.249 10.517c-.698.187-1.145.96-.958 1.657l3.967 14.806c.187.697.96 1.143 1.659.956.697-.187 1.145-.96.958-1.657l-3.617-13.5 36.633-9.816 3.617 13.5c.187.697.96 1.143 1.658.956.698-.187 1.145-.96.959-1.657l-3.968-14.806c-.186-.697-.96-1.143-1.658-.956zm-2.638 79.118c.397 1.48 1.834 2.31 3.317 1.912 1.483-.397 2.313-1.833 1.916-3.314-.396-1.48-1.834-2.309-3.316-1.912-1.483.398-2.29 1.92-1.917 3.314zm-10.636-60.626c-.396-1.48-1.834-2.309-3.316-1.911-1.483.397-2.313 1.833-1.917 3.314.397 1.48 1.834 2.308 3.317 1.911 1.483-.397 2.313-1.833 1.916-3.314z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(59.985 39.025)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#FFF",
    xlinkHref: "#c"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#D1F2F0",
    xlinkHref: "#c"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(150 118.803)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 21.849,
    cy: 28.464,
    fill: "#FFCA5D",
    rx: 21.825,
    ry: 21.986
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 49.91,
    cy: 22.182,
    fill: "#F6B545",
    rx: 21.825,
    ry: 21.986
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFCB5B",
    fillRule: "nonzero",
    d: "M49.91.196c-12.16 0-21.825 9.737-21.825 21.986 0 12.25 9.666 21.986 21.825 21.986 12.16 0 21.826-9.737 21.826-21.986C71.736 9.932 62.07.196 49.91.196zm0 37.69c-8.73 0-15.589-6.91-15.589-15.704s6.86-15.704 15.59-15.704S65.5 13.388 65.5 22.182s-6.86 15.704-15.59 15.704z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F19920",
    d: "M36.503 24.38c0-8.794 6.86-15.704 15.59-15.704 3.741 0 7.171 1.257 9.977 3.77-3.118-3.77-7.171-5.968-12.16-5.968-8.73 0-15.589 6.91-15.589 15.704 0 5.025 2.182 9.108 5.612 11.935-2.182-2.512-3.43-5.967-3.43-9.736z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFCB5B",
    d: "M59.264 31.919c-.312 0-.624 0-.935-.314-.624-.629-.624-1.57 0-2.199 1.87-1.884 2.806-4.711 2.806-7.224 0-.942.623-1.57 1.559-1.57.935 0 1.559.628 1.559 1.57 0 3.455-1.248 6.91-3.43 9.423-.624.314-1.247.314-1.559.314z"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#F19920"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.91 31.605c-1.87 0-3.117-1.257-3.117-3.141V15.9c0-1.885 1.247-3.141 3.117-3.141 1.87 0 3.118 1.256 3.118 3.14v12.564c0 1.884-1.247 3.14-3.118 3.14z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.446 40.713c-2.182-7.852-7.794-14.134-14.966-16.96-1.247-7.225-5.923-13.506-11.847-17.275-3.742 4.083-6.236 9.422-6.236 15.39 0 12.25 9.665 21.986 21.825 21.986 4.053.314 7.795-.942 11.224-3.141z"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#E78825"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.933 34.117c-2.182-2.827-3.742-6.282-3.742-10.05 0-4.398 1.871-8.48 4.989-11.307-.623-.943-1.247-1.57-1.87-2.199-3.119 2.827-4.99 6.91-4.99 11.621.001 5.025 2.183 9.108 5.613 11.935zM46.792 24.067v4.397c0 1.884 1.248 3.14 3.118 3.14 1.87 0 3.118-1.256 3.118-3.14v-.628c-1.87-1.57-4.053-2.827-6.236-3.77z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#F19920",
    d: "M60.511 37.886c-2.182 1.57-4.989 2.513-7.795 3.141-1.559.314-2.806 1.57-2.806 3.14 4.365 0 8.107-1.256 11.536-3.454l-.935-2.827z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 21.849,
    cy: 28.464,
    fill: "#F6B545",
    rx: 21.825,
    ry: 21.986
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F19920",
    d: "M18.732 44.168c0 2.198.311 4.083.935 6.281h2.182c12.16 0 21.826-9.736 21.826-21.985 0-2.199-.312-4.083-.936-6.282h-2.182c-12.16 0-21.825 9.737-21.825 21.986z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFCB5B",
    fillRule: "nonzero",
    d: "M21.85 6.478C9.69 6.478.023 16.215.023 28.464c0 12.25 9.666 21.986 21.825 21.986 12.16 0 21.826-9.737 21.826-21.986 0-12.25-9.666-21.986-21.826-21.986zm0 37.69c-8.73 0-15.59-6.91-15.59-15.704 0-8.795 6.86-15.705 15.59-15.705s15.589 6.91 15.589 15.705c0 8.794-6.86 15.704-15.59 15.704z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F6B545",
    d: "M21.85 50.135c12.16.314 21.825-9.736 21.825-21.671h-.312c-1.56 0-2.806 1.256-3.118 2.827-.624 4.397-2.806 8.48-5.924 11.307-2.494 2.512-5.924 4.083-9.665 4.711a2.804 2.804 0 0 0-2.807 2.826z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F19920",
    d: "M8.443 30.662c0-8.794 6.859-15.704 15.589-15.704 3.742 0 7.171 1.257 9.977 3.77-3.118-3.77-7.171-5.968-12.16-5.968-8.73 0-15.59 6.91-15.59 15.704 0 5.025 2.183 9.108 5.613 11.935-2.182-2.513-3.43-5.968-3.43-9.737z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFCB5B",
    d: "M31.203 38.2c-.312 0-.623 0-.935-.314-.624-.628-.624-1.57 0-2.198 1.87-1.885 2.806-4.712 2.806-7.224 0-.943.623-1.57 1.559-1.57.935 0 1.559.627 1.559 1.57 0 3.454-1.248 6.91-3.43 9.422-.624.314-1.247.314-1.559.314z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F19920",
    d: "M21.85 37.886c-1.871 0-3.118-1.256-3.118-3.14V22.182c0-1.884 1.247-3.14 3.117-3.14 1.871 0 3.118 1.256 3.118 3.14v12.564c0 1.884-1.247 3.14-3.118 3.14z"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#F6B545",
    transform: "translate(15.54 22.133)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.651.363c.624 1.885 1.247 3.77 1.247 5.968 0 8.794-6.859 15.704-15.589 15.704-.935 0-2.182 0-3.118-.314v.314c0 2.198.312 4.083.936 6.281h2.182c12.16 0 21.825-9.736 21.825-21.985 0-2.199-.312-4.083-.935-6.282h-2.183c-1.559 0-2.806 0-4.365.314z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 21.898,
    cy: 25.176,
    rx: 21.825,
    ry: 21.986
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FFCB5B",
    fillRule: "nonzero",
    d: "M37.439 25.323c-12.16 0-21.825 9.736-21.825 21.986 0 12.249 9.665 21.986 21.825 21.986s21.825-9.737 21.825-21.986c0-12.25-9.665-21.986-21.825-21.986zm0 37.69c-8.73 0-15.59-6.91-15.59-15.704 0-8.795 6.86-15.704 15.59-15.704s15.59 6.91 15.59 15.704-6.86 15.704-15.59 15.704z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFE27A",
    d: "M37.439 25.637c-12.16-.314-21.825 9.737-21.825 21.672h.311c1.56 0 2.807-1.257 3.118-2.827.624-4.397 2.806-8.48 5.924-11.307 2.494-2.513 5.924-4.083 9.666-4.711a2.804 2.804 0 0 0 2.806-2.827z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F19920",
    d: "M24.032 49.507c0-8.794 6.86-15.704 15.59-15.704 3.741 0 7.17 1.256 9.977 3.77-3.118-3.77-7.172-5.968-12.16-5.968-8.73 0-15.59 6.91-15.59 15.704 0 5.025 2.183 9.108 5.612 11.935-2.182-2.513-3.429-5.968-3.429-9.737z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFCB5B",
    d: "M46.792 57.045c-.312 0-.623 0-.935-.314-.624-.628-.624-1.57 0-2.199 1.87-1.884 2.806-4.71 2.806-7.224 0-.942.624-1.57 1.559-1.57.935 0 1.559.628 1.559 1.57 0 3.455-1.247 6.91-3.43 9.423-.623.314-1.247.314-1.559.314z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F19920",
    d: "M37.439 56.731c-1.871 0-3.118-1.256-3.118-3.14V41.026c0-1.885 1.247-3.14 3.118-3.14 1.87 0 3.118 1.256 3.118 3.14V53.59c0 1.885-1.247 3.141-3.118 3.141z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    fill: "#FFF",
    xlinkHref: "#d"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#C1E7E4",
    xlinkHref: "#d"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#AEDBD7",
    d: "M162.992 172.272h-1.572c1.04.532 2.07 1.096 3.05 1.771l74.947 58.04V119.107l-76.425 53.165z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(187 180)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 36,
    r: 36,
    fill: "#D70000"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M39.637 36l10.91-10.91-3.637-3.636L36 32.364l-10.91-10.91-3.636 3.636L32.364 36l-10.91 10.91 3.636 3.636L36 39.636l10.91 10.91 3.636-3.636z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStateNomoney);
export default __webpack_public_path__ + "static/media/state-nomoney.483d5082aa249dbb704910f38b66c0ca.svg";
export { ForwardRef as ReactComponent };